<style src="./style.scss">
</style>

<script lang="ts">
  export let title:string;
  export let active:boolean = false;
  export let onClick:any = () => null;
</script>

<div
  class="{`billing-frequency ${active ? 'billing-frequency__active' : ''}`}"
  on:click="{onClick}">
  {title}
</div>
